import React, { useState, useRef } from 'react';
import { awards } from '../data.js';
import { FaAward } from 'react-icons/fa';
import { HiChevronDown } from 'react-icons/hi';

export default function Awards({sectionBg}) {
  const [showAll, setShowAll] = useState(false);
  const sectionRef = useRef(null);

  const awardsPerRow = 3;
  const initialCount = awardsPerRow * 2; // 2 rows initially

  // Sort awards by date descending
  const sortedAwards = [...awards].sort((a, b) => new Date(b.date) - new Date(a.date));

  const displayedAwards = showAll ? sortedAwards : sortedAwards.slice(0, initialCount);

  const handleToggle = () => {
    setShowAll((prev) => {
      if (prev) {
        // scroll to top of section when collapsing
        sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
      }
      return !prev;
    });
  };
   const cardBg = sectionBg === "bg-gray-50" ? "bg-white" : "bg-gray-50";
  return (
    <section id="awards" className={sectionBg + " py-16"} ref={sectionRef}>
      <div className="max-w-6xl mx-auto px-6 py-16">
        <h2 className="text-3xl font-bold mb-12 text-center">Awards</h2>

        <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {displayedAwards.map((award, index) => (
            <div
              key={index}
              className={cardBg + " p-6 rounded-lg shadow hover:shadow-xl transition transform hover:-translate-y-1 flex items-start space-x-4"}
            >
              <div className="text-yellow-500 mt-1">
                <FaAward className="w-6 h-6" />
              </div>
              <div>
                <h3 className="text-gray-800 font-semibold text-lg">{award.title}</h3>
                <p className="text-gray-500 mt-1">{award.organisation}</p>
                <p className="text-gray-400 text-sm mt-1">{award.date}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Toggle Button */}
        {awards.length > initialCount && (
          <div className="mt-6 text-center">
            <button
              onClick={handleToggle}
              className="p-2 rounded-full bg-blue-600 text-white hover:bg-blue-700 transition transform"
            >
              <HiChevronDown
                className={`w-6 h-6 transition-transform duration-300 ${
                  showAll ? 'rotate-180' : ''
                }`}
              />
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
